<template>
  <div id="afdc-analyze-results" aria-live="polite">
    <button v-if="stationCount > 0 || !$store.getters.getAnalyzeShowFilters" class="afdc-btn afdc-btn-secondary" id="afdc-map-results" @click="toggleMapAndFilters">
      <template v-if="$store.getters.getAnalyzeShowFilters">
        <font-awesome-icon icon="map-marker-alt" class="afdc-fa-icon"/>&nbsp;
        {{ $t('Map Results') }}
      </template>
      <template v-else>
        <font-awesome-icon icon="filter" class="afdc-fa-icon"/>&nbsp;
        {{ $t('Edit Filters') }}
      </template>
    </button>
    <div class="afdc-analyze-results-count">
      <div v-if="$store.getters.getLoadingAnalyzeResults">
        <div class="afdc-analyze-spinner"></div>
      </div>
      <div v-else>
        <h3 v-html="stationCountText"></h3>
        <h3 class="afdc-charging-count">
          <div v-html="electricCountText" class="afdc-electric-count-text"></div>
          <a href="#" v-on:click.prevent="toggleEvTerms" v-if="electricCountText" id="afdc-ev-terms-link">
            <font-awesome-icon icon="question-circle" class="afdc-fa-icon"/>
          </a>
        </h3>
      </div>
    </div>

    <h4>{{ $t('Filters chosen:') }}</h4>
    <hr/>
    <div id="afdc-analyze-results-filters">
    <div class="afdc-row afdc-no-gutters afdc-analyze-filters-section">
      <div class="afdc-col-auto">
        <div class="afdc-analyze-filters-section-icon">
          <img src="../assets/images/icon-analyze-location.png" v-bind:alt="$t('Location')">
        </div>
      </div>
      <div class="afdc-col">
        <ul>
          <li>
            <div v-if="filterRadius">{{ filterRadius }}</div>
            {{ filterLocation }}
          </li>
        </ul>
      </div>
    </div>
    <hr/>
    <div class="afdc-row afdc-no-gutters afdc-analyze-filters-section">
      <div class="afdc-col-auto">
        <div class="afdc-analyze-filters-section-icon">
          <img src="../assets/images/icon-analyze-fuel.png" v-bind:alt="$t('Fuel')">
        </div>
      </div>
      <div class="afdc-col">
        <ul class="afdc-analyze-filters-fuels">
          <li v-if="filterAllFuels">{{ filterAllFuels }}</li>
          <li v-if="filterValueFuel.length === 0">{{ $t('None') }}</li>
          <li v-if="filterValueFuel.includes('BD')">
            <strong>{{ $store.getters.loaderFuelNamesByKey['BD'] }}</strong>
          </li>
          <li v-if="filterValueFuel.includes('CNG')">
            <strong>{{ $store.getters.loaderFuelNamesByKey['CNG'] }}</strong>
            <ul>
              <li v-if="filterFuelCngFillType">{{ filterFuelCngFillType }}</li>
              <li v-if="filterFuelCngVehicleClass">{{ filterFuelCngVehicleClass }}</li>
              <li v-if="filterFuelCngPsis">{{ filterFuelCngPsis }}</li>
            </ul>
          </li>
          <li v-if="filterValueFuel.includes('ELEC')">
            <strong>{{ $store.getters.loaderFuelNamesByKey['ELEC'] }}</strong>
            <ul>
              <li v-if="filterFuelElecLevels"><strong>{{ $t('Types:') }}</strong> {{ filterFuelElecLevels }}</li>
              <li v-if="filterFuelElecConnectors"><strong>{{ $t('Connectors:') }}</strong> {{ filterFuelElecConnectors }}</li>
              <li v-if="filterFuelElecNetworks"><strong>{{ $t('Networks:') }}</strong> {{stationEvNetworksByKey(filterFuelElecNetworks)}}</li>
            </ul>
          </li>
          <li v-if="filterValueFuel.includes('E85')">
            <strong>{{ $store.getters.loaderFuelNamesByKey['E85'] }}</strong>
            <ul>
              <li v-if="filterFuelE85Blends">{{ filterFuelE85Blends }}</li>
            </ul>
          </li>
          <li v-if="filterValueFuel.includes('HY')">
            <strong>{{ $store.getters.loaderFuelNamesByKey['HY'] }}</strong>
            <ul>
              <li v-if="filterFuelHydrogenNonRetail">{{ filterFuelHydrogenNonRetail }}</li>
            </ul>
          </li>
          <li v-if="filterValueFuel.includes('LNG')">
            <strong>{{ $store.getters.loaderFuelNamesByKey['LNG'] }}</strong>
            <ul>
              <li v-if="filterFuelLngVehicleClass">{{ filterFuelLngVehicleClass }}</li>
            </ul>
          </li>
          <li v-if="filterValueFuel.includes('LPG')">
            <strong>{{ $store.getters.loaderFuelNamesByKey['LPG'] }}</strong>
            <ul>
              <li v-if="filterFuelLpgSecondary">{{ filterFuelLpgSecondary }}</li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <hr/>
    <div class="afdc-row afdc-no-gutters afdc-analyze-filters-section">
      <div class="afdc-col-auto">
        <div class="afdc-analyze-filters-section-icon">
          <img src="../assets/images/icon-analyze-station.png" v-bind:alt="$t('Station')">
        </div>
      </div>
      <div class="afdc-col">
        <ul>
          <li><strong>{{ $t('Access:') }}</strong> {{ filterAccess }}</li>
          <li v-if="filterStatus"><strong>{{ $t('Status:') }}</strong> {{ filterStatus }}</li>
          <li v-if="filterOwner"><strong>{{ $t('Owner:') }}</strong> {{ filterOwner }}</li>
          <li v-if="filterPayment"><strong>{{ $t('Payment:') }}</strong> {{ filterPayment }}</li>
        </ul>
      </div>
    </div>
    </div>

    <div class="afdc-analyze-download afdc-kiosk-mode-hide">
      <a v-bind:href="analyzeCsv" v-bind:class="analyzeCsvLinkClass" v-bind:aria-diabled="analyzeCsvLinkAriaDisabled" v-bind:tabindex="analyzeCsvLinkTabindex" role="button">
        <font-awesome-icon icon="download" class="afdc-fa-icon"/>{{ $t('Download Results') }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    stationCount() {
      return this.$store.getters.analyzeCount;
    },

    stationCountText() {
      const count = this.stationCount;
      if (count === null) {
        return null;
      }

      return this.$sprintf(this.$ngettext('%s station location', '%s station locations', count), `<span>${this.$formatNumber(count)}</span>`);
    },

    electricCountText() {
      const count = this.$store.getters.analyzeElectricPortCount;
      if (count === null) {
        return null;
      }

      const fuels = this.filterValueFuel;
      if (fuels.includes('ELEC')) {
        return this.$sprintf(this.$ngettext('%s EVSE port', '%s EVSE ports', count), `<span>${this.$formatNumber(count)}</span>`);
      }
      return null;
    },

    analyzeCsv() {
      if (this.stationCount === 0) {
        return '#';
      }
      return this.$store.getters.analyzeCsv;
    },

    analyzeCsvLinkClass() {
      const classes = ['afdc-btn'];
      if (this.stationCount === 0) {
        classes.push('afdc-disabled');
      }

      return classes;
    },

    analyzeCsvLinkAriaDisabled() {
      if (this.stationCount === 0) {
        return 'true';
      }
      return 'false';
    },

    analyzeCsvLinkTabindex() {
      if (this.stationCount === 0) {
        // When the link is disabled, also set it's tabindex to -1 for
        // accessibility (so keyboard users can't still navigate and click on
        // it).
        return '-1';
      }
      return '0';
    },

    filterLocation() {
      const mode = this.$store.getters.getFilterValueWithDefault('location_mode');
      if (mode === 'address') {
        return this.$store.getters.getFilterValueWithDefault('location');
      }

      const region = this.$store.getters.getFilterValueWithDefault('region');
      if (region !== 'all') {
        const regionNames = this.$store.getters.loaderRegionNamesByKey;
        return regionNames[region];
      }

      const countryNames = this.$store.getters.loaderCountryNamesByKey;
      return countryNames[this.$store.getters.getCountry];
    },

    filterRadius() {
      const mode = this.$store.getters.getFilterValueWithDefault('location_mode');
      if (mode === 'address') {
        let message;
        if (this.$store.getters.getFilterValueWithDefault('radius_unit') === 'km') {
          message = this.$t('Within %s km of:');
        } else {
          message = this.$t('Within %s mi of:');
        }
        return this.$sprintf(message, this.$formatNumber(this.$store.getters.getFilterValueWithDefault('radius')));
      }
      return null;
    },

    filterAccess() {
      const access = this.$store.getters.getFilterValueWithDefault('access');
      const showPublic = access.includes('public');
      const showPrivate = access.includes('private');
      if (showPublic && showPrivate) {
        return this.$pgettext('access|', 'Public & private');
      }
      if (showPublic) {
        return this.$pgettext('access|', 'Public');
      }
      if (showPrivate) {
        return this.$pgettext('access|', 'Private');
      }
      return this.$t('None');
    },

    filterStatus() {
      const values = this.$store.getters.getFilterValueWithDefault('status');
      if (values.length === 1 && values[0] === 'E') {
        return null;
      }
      if (values.length === 0) {
        return this.$t('None');
      }
      const names = this.$store.getters.loaderStatusTypeNamesByKey;
      return values.map((key) => names[key]).sort().join(', ');
    },

    filterValueFuel() {
      return this.$store.getters.getFilterValueWithDefault('fuel');
    },

    fuelNamesByKey() {
      return this.$store.getters.loaderFuelNamesByKey;
    },

    filterAllFuels() {
      const values = this.filterValueFuel;
      if (values.includes('all')) {
        const names = this.fuelNamesByKey;
        return values.map((key) => names[key]).sort().join(', ');
      }
      return null;
    },

    filterFuelCngFillType() {
      const value = this.$store.getters.getFilterValueWithDefault('cng_fill_type');
      if (value !== 'all') {
        const names = this.$store.getters.loaderCngFillTypesByKey;
        return names[value];
      }
      return null;
    },

    filterFuelCngVehicleClass() {
      const value = this.$store.getters.getFilterValueWithDefault('cng_vehicle_class');
      if (value !== 'all') {
        const names = this.$store.getters.loaderCngVehicleClassesByKey;
        return names[value];
      }
      return null;
    },

    filterFuelCngPsis() {
      const values = this.$store.getters.getFilterValueWithDefault('cng_psis');
      if (!values.includes('all')) {
        const names = this.$store.getters.loaderCngPsisByKey;
        return values.map((key) => names[key]).sort().join(', ');
      }
      return null;
    },

    filterFuelElecLevels() {
      const values = this.$store.getters.getFilterValueWithDefault('ev_levels');
      if (!values.includes('all')) {
        const names = this.$store.getters.loaderElecLevelsByKey;
        return values.map((key) => names[key]).sort().join(', ');
      }
      return null;
    },

    filterFuelElecConnectors() {
      const values = this.$store.getters.getFilterValueWithDefault('ev_connectors');
      if (!values.includes('all')) {
        const names = this.$store.getters.loaderElecConnectorsByKey;
        return values.map((key) => names[key]).sort().join(', ');
      }
      return null;
    },

    filterFuelElecNetworks() {
      const values = this.$store.getters.getFilterValueWithDefault('ev_networks');
      if (!values.includes('all')) {
        const names = this.$store.getters.loaderElecNetworksByKey;
        return values.map((key) => names[key]);
      }
      return null;
    },

    filterFuelE85Blends() {
      const value = this.$store.getters.getFilterValueWithDefault('e85_blends');
      if (value === true) {
        return this.$t('Only stations with mid-level blends');
      }
      return null;
    },

    filterFuelLngVehicleClass() {
      const value = this.$store.getters.getFilterValueWithDefault('lng_vehicle_class');
      if (value !== 'all') {
        const names = this.$store.getters.loaderLngVehicleClassesByKey;
        return names[value];
      }
      return null;
    },

    filterFuelHydrogenNonRetail() {
      const value = this.$store.getters.getFilterValueWithDefault('hy_nonretail');
      if (value === true) {
        return this.$t('Includes non-retail stations');
      }
      return null;
    },

    filterFuelLpgSecondary() {
      const value = this.$store.getters.getFilterValueWithDefault('lpg_secondary');
      if (value === true) {
        return this.$t('Includes stations with limited vehicle-specific fueling capabilities');
      }
      return null;
    },

    filterOwner() {
      const value = this.$store.getters.getFilterValueWithDefault('owner');
      if (value !== 'all') {
        const names = this.$store.getters.loaderOwnerTypeNamesByKey;
        return names[value];
      }
      return null;
    },

    filterPayment() {
      const value = this.$store.getters.getFilterValueWithDefault('payment');
      if (value !== 'all') {
        const names = this.$store.getters.loaderPaymentMethodNamesByKey;
        return names[value];
      }
      return null;
    },
  },

  watch: {
    '$store.getters.getFiltersAnalyze': {
      immediate: true,
      handler: 'fetchData',
    },

    '$store.getters.isNavActiveTabAnalyze': 'fetchData',

    '$route.query.show_map': {
      immediate: true,
      handler: 'setAnalyzeShowFilters',
    },

    '$route.query.show_ev_terms': {
      immediate: true,
      handler: 'setEvTermsModalOpen',
    },
  },

  methods: {
    toggleMapAndFilters() {
      if (this.$store.getters.getAnalyzeShowFilters) {
        this.$router.push({ query: { ...this.$route.query, show_map: 'true' } });
      } else {
        this.$router.push({ query: { ...this.$route.query, show_map: undefined } });
      }
    },

    setAnalyzeShowFilters() {
      if (this.$route.query.show_map === 'true' || (this.$route.name === 'StationShow' && this.$store.getters.isNavActiveTabAnalyze)) {
        this.$store.dispatch('fetchAnalyzeMapStations', this.$store.getters.getFiltersWithDefaults);
        this.$store.commit('setAnalyzeShowFilters', false);
      } else {
        this.$store.commit('setAnalyzeShowFilters', true);
      }
    },

    fetchData() {
      if (this.$store.getters.isNavActiveTabAnalyze) {
        this.$store.dispatch('fetchAnalyzeResults', this.$store.getters.getFiltersWithDefaults);
      }
    },

    setEvTermsModalOpen() {
      if (this.$route.query.show_ev_terms === 'true') {
        this.$store.commit('setEvTermsModalOpen', true);
      } else {
        this.$store.commit('setEvTermsModalOpen', false);
      }
    },

    toggleEvTerms() {
      this.$store.commit('setEvTermsModalLinkClicked', true);
      if (this.$store.getters.getEvTermsModalOpen) {
        this.$router.push({ query: { ...this.$route.query, show_ev_terms: undefined } });
      } else {
        this.$router.push({ query: { ...this.$route.query, show_ev_terms: 'true' } });
      }
    },
  },
};
</script>

<style lang="scss">
@import '~spinthatshit/src/loaders.scss';

.analyze-spinner {
  @include loader02($color: #fff);
}

#analyze-results {
  text-align: center;

  #map-results {
    margin-top: 20px;
    color: #292b2c;
    background-color: #fff;
    border-color: #ccc;
    &:hover {
      background-color: #ddd;
    }
  }

  .analyze-results-count {
    height: 195px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #analyze-results-filters {
    height: auto;
    max-height: 275px;
    overflow: auto;
    margin-bottom: 100px;
  }

  .analyze-download {
    position: absolute;
    bottom: 10px;
    margin: 0 auto;
    left: 50%;
    margin-left: -85px;
    a {
      color: #fff;
    }
    .fa-icon {
      font-size: 20px;
      margin-right: 10px;
    }
  }

  h3 {
    font-size: 20px;
    font-weight: 100;
    margin: 20px 0px 0px 0px;
    span {
      display: block;
      font-size: 54px;
      line-height: 48px;
    }
  }

  h3.charging-count {
    font-size: 15px;
    margin: 10px 0px 15px 0px;
    span {
      font-size: 30px;
      line-height: 28px;
    }
  }

  div.electric-count-text {
    display: inline;
  }

  #ev-terms-link {
    color: #fff;
    &:hover {
      color: #ddd;
    }
  }

  h4 {
    font-weight: normal;
    margin: 20px 0px 10px 0px;
    color: #fff;
    font-size: 16px;
  }

  ul {
    list-style-type: none;
    text-align: left;
    padding: 0px;
    margin: 3px 0px 0px 0px;

    ul {
      margin: 0px;
      padding-left: 20px;
    }
  }

  hr {
    width: 80%;
    background-color: #aaa;
    margin: 0px auto;
  }

  .analyze-filters-section {
    font-size: 15px;
    margin: 10px 0px;

    .fa-icon {
      color: #777;
      font-size: 40px;
    }
  }

  .analyze-filters-section-icon {
    width: 60px;
    opacity: 0.5;
    text-align: center;
    margin-right: 10px;
  }

  ul.analyze-filters-fuels > li {
    margin-bottom: 8px;
  }
}
</style>
